<template>
  <b-container>
    <b-row>
      <h2>{{ $t("tracking.cargo.list") }}</h2>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>
    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template v-slot:cell(actions)="row">
          <b-button size="sm" @click="row.toggleDetails">
            {{
              row.detailsShowing
                ? $t("geral.ocultarDetalhes")
                : $t("geral.exibirDetalhes")
            }}
          </b-button>
        </template>
        <template v-slot:row-details="row">
          <div id="div-ocorrencias">
            <b-card title="Detalhes da entrega">
              <tracking-client-timeLine :id="row.item.id.toString()">
              </tracking-client-timeLine>
            </b-card>
          </div>
        </template>
        <!-- <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.key">
              <div v-if="tableFilters[field.filterKey] != null">		
                <b-form-select
                    v-if="field.filterKey == 'cargoActive'"
                    :options="optionsBoolean"
                    v-model="tableFilters[field.filterKey]"
                >
                </b-form-select>
                <b-form-input
                  v-else
                  v-model="tableFilters[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </b-th>
          </b-tr>
        </template> -->
      </b-table>
    </b-row>

    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </b-container>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import TablePaginationProps from "@/components_rms/base/TablePaginationProps.vue";
import TrackingClientTimeLine from "@/components_rms/trackingClient/TrackingClientTimeLine.vue";

export default {
  name: "FormSchedules",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    TablePaginationProps,
    TrackingClientTimeLine,
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      isBusy: false,
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        // {
        //   key: "id",
        //   filterKey: "id",
        //   sortable: false,
        //   label: "Id",
        //   tdClass: "table-col-dinamic-width",
        // },
        {
          key: "deliveryNumber",
          filterKey: "deliveryNumber",
          label: "Número entrega",
          sortable: true,
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "lastOccurrenceDate",
          filterKey: "lastOccurrenceDate",
          label: "Última ocorrência",
          sortable: true,
          formatter: (value, key, item) => {
            let date = new Date(value);
            return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
          },
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "lastStatusDescription",
          filterKey: "lastStatusDescription",
          label: "Situação",
          sortable: true,
        },
      ],
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      tableFilters: {
        cargoId: "",
        cargoName: "",
        cargoDescription: "",
        cargoActive: true,
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  methods: {
    getUrlEdit(cargo) {
      console.log(cargo);
      return `/trackingShippingCompany/cargo/edit/${cargo.cargoId}`;
    },
    getUrlFilledDetails(cargo) {
      return "/trackingShippingCompany/cargo/details/" + cargo.checklistId;
    },
    isCargoActive(cargo) {
      if (cargo) {
        return cargo.cargoActive;
      }
      return false;
    },
    isCargoEditable(cargo) {
      console.log(`cargo: ${cargo}`);
      if (!this.isCargoActive(cargo)) {
        return false;
      }
      if (!cargo) {
        return false;
      }
      if (cargo.isInUse) {
        return false;
      }
      return true;
    },
    myProvider(ctx) {
      this.isBusy = true;

      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        // cargoId: ctx.filter.cargoId,
        // cargoName: ctx.filter.cargoName,
        // cargoDescription: ctx.filter.cargoDescription,
        // cargoActive: true
      };

      return this.$api
        .post("/v1/deliveryClient/finished", apiParam)
        .then((response) => {
          const items = response.data.items;
          console.log(items);
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          return items;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            return [];
          }
        });
    },
    cargoActivate(cargo) {
      this.$api
        .get("/cargo/activate/" + cargo.cargoId.toString())
        .then((response) => {
          cargo.cargoActive = true;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    vechicleTypeDeactivate(cargo) {
      this.$api
        .get("/cargo/deactivate/" + cargo.cargoId.toString())
        .then((response) => {
          cargo.cargoActive = false;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log(error);
          console.log(`error.response: ${error.response}`);
          console.log(error.response);

          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
  },
};
</script>
